import React, { useState } from 'react';
import { PrizeCardsMessage } from '../../../domain/richMessage.interface';
import { TextCard } from './TextCard';

interface PrizeCardProps {
  data: PrizeCardsMessage;
  onSelect: (labels: string[]) => void;
}

export const PrizeCard: React.FC<PrizeCardProps> = ({ data, onSelect }) => {
  const storageKey = `prizeCard_${data.prizes.map((p) => p.id).join('_')}`;

  const [selectedId, setSelectedId] = useState<string | null>(() =>
    localStorage.getItem(storageKey)
  );

  const handleSelect = (id: string, name: string) => {
    if (selectedId) return;
    setSelectedId(id);
    localStorage.setItem(storageKey, id);
    onSelect([name]);
  };

  return (
    <div>
      <TextCard message={data.text} />
      <p className="text-navy-64 text-xs font-bold uppercase tracking-widest mt-3 mb-2 px-1">
        CHOOSE YOUR PRIZE
      </p>
      <div className="flex flex-col gap-2">
        {data.prizes.map((prize) => (
          <button
            key={prize.id}
            onClick={() => handleSelect(prize.id, prize.name)}
            className={`text-left border rounded-xl p-3 transition-colors w-full ${
              selectedId
                ? selectedId === prize.id
                  ? 'border-coral pointer-events-none'
                  : 'border-black/[0.12] opacity-40 pointer-events-none'
                : 'border-black/[0.12] hover:border-navy/20'
            }`}
          >
            <p className="text-coral text-[10px] font-bold uppercase">{prize.label}</p>
            <p className="text-navy font-bold text-sm mt-0.5">{prize.name}</p>
            <p className="text-navy-64 text-xs mt-0.5">{prize.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
